import Vue from "vue";
import Router from "vue-router";
import Login from "../components/login/Login.vue";
import SuitabilityComponent from "cb-components-suitability";
import Home from "../components/home/Index";
import Information from "../components/account/Information";
import Ranking  from "cb-components-ranking";
import Portfolio from "cb-components-portfolio";
import AnalystRating from "cb-components-analyst-rating";
import CompanyEvaluate from "cb-components-company-evaluate";
import {CompanyReport} from "cb-components-company-evaluate";
import PortfolioAnalyst from "cb-components-portfolio-analysis";
import ManagerTagging from "cb-components-manager-tagging";
import MorningstarAward from "cb-components-morningstar-award";

Vue.use(Router);
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    mode: "hash",
    routes: [{
            path: "/",
            name: "Login",
            component: Login
        },
        {
            path: "/home",
            component: Home
        },
        {
            path: "/suitability",
            component: SuitabilityComponent.Suitability
        },
        {
            path: "/information",
            component: Information
        },
        {
            path: "/login",
            component: Login
        },
        {
            path: "/ranking",
            component: Ranking
        },
        {
            path: "/company-evaluate",
            component: CompanyEvaluate
        },
        {
            path: "/portfolio",
            component: Portfolio
        },
        {
            path: "/analyst-rating",
            component: AnalystRating
        },
        {
            path: "/portfoliodiagnostic",
            component: PortfolioAnalyst,
            meta: {
                keepAlive: true
            }
        },
        {
            name: "CompanyReport",
            path: "/company-report",
            component: CompanyReport
        },
        {
            path: "/manager-tagging",
            component: ManagerTagging
        },
        {
            path: "/morningstar-award",
            component: MorningstarAward
        }
    ]
});
